import { render, staticRenderFns } from "./DownloadList2.vue?vue&type=template&id=bd1cc650&"
import script from "./DownloadList2.vue?vue&type=script&lang=js&"
export * from "./DownloadList2.vue?vue&type=script&lang=js&"
import style0 from "./DownloadList2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports